// removed by extract-text-webpack-plugin
module.exports = {"reset-icon":"style__reset-icon___2bqan","search-container":"style__search-container___1_IEn","search-input":"style__search-input___3V1Jj"};


//////////////////
// WEBPACK FOOTER
// ./components/SearchInput/style.scss
// module id = 1289
// module chunks = 0